import React from 'react';
import { Link } from 'react-router-dom';
import './CemeteryCard.css';

function CemeteryCard({ cemetery, lastBackup, lastImport, lastWipe }) {
    // Format date if available
    const formatDate = (dateString) => {
        if (!dateString) return 'Never';
        try {
            return new Date(dateString).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (e) {
            return dateString;
        }
    };

    return (
        <div className="cemetery-card">
            <div className="cemetery-card-header">
                <h3 className="cemetery-name" title={cemetery.name}>{cemetery.name}</h3>
                <span className="cemetery-id">{cemetery.unique_name}</span>
            </div>

            <div className="cemetery-card-body">
                <div className="info-row">
                    <span className="info-label">Region:</span>
                    <span className="info-value">{cemetery.database_location || 'Unknown'}</span>
                </div>
                <div className="info-row">
                    <span className="info-label">Last Backup:</span>
                    <div className="info-value-group">
                        <span className={`info-value ${!lastBackup ? 'text-warning' : ''}`}>
                            {formatDate(lastBackup?.completed_at || lastBackup?.created_at)}
                        </span>
                        {lastBackup?.username && (
                            <span className="info-subtext">by {lastBackup.username}</span>
                        )}
                    </div>
                </div>
                <div className="info-row">
                    <span className="info-label">Last Import:</span>
                    <div className="info-value-group">
                        <span className={`info-value ${!lastImport ? 'text-muted' : ''}`}>
                            {formatDate(lastImport?.completed_at || lastImport?.created_at)}
                        </span>
                        {lastImport?.username && (
                            <span className="info-subtext">by {lastImport.username}</span>
                        )}
                    </div>
                </div>
                <div className="info-row">
                    <span className="info-label">Last Wipe:</span>
                    <div className="info-value-group">
                        <span className={`info-value ${!lastWipe ? 'text-muted' : ''}`}>
                            {formatDate(lastWipe?.created_at)}
                        </span>
                        {lastWipe?.username && (
                            <span className="info-subtext">by {lastWipe.username}</span>
                        )}
                    </div>
                </div>
            </div>

            <div className="cemetery-card-actions">
                <Link
                    to={`/backup?cemetery=${cemetery.unique_name}`}
                    className="card-action-btn btn-backup"
                    title="Create Backup"
                >
                    <span>📦</span> Backup
                </Link>
                <Link
                    to={`/import?cemetery=${cemetery.unique_name}`}
                    className="card-action-btn btn-import"
                    title="Import Data"
                >
                    <span>📥</span> Import
                </Link>
            </div>
        </div >
    );
}

export default CemeteryCard;
